import useSWR, { SWRConfiguration } from 'swr'

import { ThroughputResponse } from '@infura/packages.api'
import { isAxiosError } from '@infura/packages.common/errors'

import { api } from 'lib/api/api'

const defaultUsageFetcherConfig: SWRConfiguration = {
  errorRetryCount: 1,
  errorRetryInterval: 60000,
  focusThrottleInterval: 30000,
  loadingTimeout: 30000
}

const getThroughput = async () => {
  try {
    const response = await api.getThroughput({
      datapoint: 'count',
      query: 'throughput',
      time: {
        from: '30d',
        tick: 'd'
      },
      userTimestamp: new Date().toISOString().split('.')[0] + 'Z'
    })

    return response.data
  } catch (e: any) {
    if (isAxiosError(e)) {
      throw e?.response?.data
    }
    throw e
  }
}

export const useThroughput = ({ refreshInterval = 0 }: { refreshInterval?: number; keys: Array<string> }) => {
  const swrConfig = {
    ...defaultUsageFetcherConfig,
    fetcher: getThroughput,
    refreshInterval,
    refreshWhenHidden: false, //  don't refresh when the page is not visible
    refreshWhenOffline: false
  }

  const { data: throughputData, ...rest } = useSWR(['throughput'], swrConfig)

  return {
    throughputData: throughputData as ThroughputResponse,
    ...rest
  }
}
